// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"59":"2d923cba","830":"96badcc9","831":"6d0e17d7"}[chunkId] + ".js";
};